<header
  class="site-header"
  [class.scrolled]="scrolled">
  <div class="header-inner">
    <!-- =====================================
         LOGO
    ====================================== -->
    <a
      class="brand"
      href="#top"
      (click)="closeMenu()"
      [attr.aria-label]="company.fullName">
      <!-- <span class="brand-symbol">
        <span class="flame flame-a"></span>
        <span class="flame flame-b"></span>
      </span> -->
      <a
  class="header-logo"
  href="#top"
  aria-label="Maize Trading FZC">
  <img
    [src]="company.image"
    alt="Maize Trading FZC">
</a>

 
      <span class="brand-name">
        <strong>
          {{ company.name }}
</strong>
        <small>
          {{ company.legalName }}
</small>
      </span>
    </a>
    <!-- =====================================
         NAVIGATION
    ====================================== -->
    <nav
      class="main-nav"
      [class.open]="menuOpen"
      aria-label="Main navigation">
      @for (item of navigation; track item.label) {
        <a
          [href]="item.url"
          [class.active]="item.label === 'Home'"
          (click)="closeMenu()">
          {{ item.label }}
        </a>
      }
    </nav>
    <!-- =====================================
         HEADER TOOLS
    ====================================== -->
    <!-- <div class="header-tools">
      
      <button
        class="icon-btn"
        type="button"
        aria-label="Search">
        <span class="search-icon"></span>
      </button>
      
      <button
        class="language"
        type="button">
        EN
        <span>⌄</span>
      </button>
    </div> -->
    <!-- =====================================
         MOBILE MENU
    ====================================== -->
    <button
      class="menu-toggle"
      type="button"
      (click)="toggleMenu()"
      [attr.aria-expanded]="menuOpen"
      aria-label="Toggle navigation">
      <span></span>
<span></span>
<span></span>
    </button>
  </div>
</header>
